import { autoinject } from "aurelia-framework";
import { PscRoutes } from "../../constants/psc.constants";
import { GetPscCloseOutDocumentLinksResponse } from "../../models/psc/psc.models";
import { RequestClientService, ResponseType } from "../basic/request-client.service";

@autoinject
export class PscService {

    constructor(private requestClient: RequestClientService) { }

    public getPscThumbnailZipFile(id: number): Promise<any> {
        return this.requestClient.get<Blob>(`${PscRoutes.GetPscThumbnailZipFile}/${id}`, {}, ResponseType.Blob);
    }

    public getPscCloseOutDocumentLinks(id: number): Promise<GetPscCloseOutDocumentLinksResponse> {
        return this.requestClient.get(`${PscRoutes.GetPscCloseOutDocumentLinks}/${id}`, {});
    }
}
